import Radium from "radium";
import React from "react";
import PropTypes from 'prop-types';
import Translate from "../../../../components/TranslateFormat";
import WarningIcon from "../../../../assets/icons/WarningIcon";
import classNames from "classnames";
import BlueButton from "../../../../components-new/buttons/BlueButton";
import SilverButton from "../../../../components-new/buttons/SilverButton";
import Colors from "../../../../utils/Colors";

const styles = {
    modalContent: {
        background: 'var(--ds-bg-primary)',
        width: '452px',
        padding: '15px 20px'
    },
    buttonStyle: {
        marginRight: '25px',
        marginBottom: '10px',
    },
    continueButtonStyle: {
        width: '140px',
        border: 'none',
        backgroundColor: '#F04D4D',
        color: 'var(--ds-text-on-solid)',
        fontSize: '16px',
        WebkitBoxShadow: '2px 2px 5px 0px rgba(24, 62, 153, 0.17)',
        MozBoxShadow: '2px 2px 5px 0px rgba(24, 62, 153, 0.17)',
        boxShadow: '2px 2px 5px 0px rgba(24, 62, 153, 0.17)',
    },
    cancelButtonStyle: {
        width: '140px',
        marginRight: '10px',
        marginLeft: '20px',
        border: 'none',
        backgroundColor: 'var(--ds-bg-primary)',
        color: '#09183A',
        fontSize: '16px',
        WebkitBoxShadow: '2px 2px 5px 0px rgba(24, 62, 153, 0.17)',
        MozBoxShadow: '2px 2px 5px 0px rgba(24, 62, 153, 0.17)',
        boxShadow: '2px 2px 5px 0px rgba(24, 62, 153, 0.17)',
    },
    circleWrapper: {
        display: 'flex',
        justifyContent: 'center',
    },
    circle: {
        backgroundColor: '#E14E52',
        borderRadius: '50%',
        height: '90px',
        width: '90px',
        display: 'flex',
        alignContent: 'center',
        padding: '24px 24px',
    },
};

const companyDataPartialErrorMessage = "companyPartialDataError";
const Type = {INFO: 1, REDIRECT: 2};

const renderInfoButton = (closeModal) => {
    return (
        <BlueButton type={'button'} onClick={closeModal} children={<Translate text={'ok'}/>}/>
    )
};

const renderRedirectButton = (closeModal) => {
    return (
        <div style={{textAlign: 'center', display: 'flex'}}>
            <BlueButton type={'button'}
                        onClick={closeModal}
                        children={<Translate text={'ok'}/>}/>
        </div>
    )
};

const ErrorContent = ({errorMessage, closeModal}) => {
    let messageKey, values;
    let popupType = Type.INFO;
    if (errorMessage) {
        messageKey = errorMessage.data.messageKey;
        values = errorMessage.data.values;
        if (messageKey === companyDataPartialErrorMessage) popupType = Type.REDIRECT
    } else {
        messageKey = "WARNING";
        values = [];
    }
    return (
        <div style={styles.modalContent}>
            <div style={styles.circleWrapper}>
                <div style={styles.circle}>
                    <div>
                        <WarningIcon style={{color: Colors.blueExtraLite2}} stroke="currentColor" size={40}/>
                    </div>
                </div>
            </div>
            <div style={{margin: '35px', textAlign: 'center'}}>
                <Translate text={messageKey ? messageKey : 'somethingWentWrong'} values={values}/>
            </div>
            {
                Type.INFO === popupType ? renderInfoButton(closeModal) : renderRedirectButton(closeModal)
            }
        </div>
    )
};

ErrorContent.propTypes = {
    errorMessage: PropTypes.object.isRequired,
    closeModal: PropTypes.func.isRequired,
};

export default Radium(ErrorContent)



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/billing/ErrorContent.jsx